import { datatableSearchSchema } from '@/lib/utils/datatableSearchSchema'
import { stringifyValues } from '@/lib/utils/queries'
import { getApi } from '@/stores/api'
import { INVESTMENT_CATEGORIES, PRODUCT_CATEGORIES } from '@repo/constants'
import { monthStartString } from '@repo/zod-schemas'
import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

// TODO(customer-investments-filters): wire up the following search params + filter UI.
//   - sapErp:    filter by individual customer SAP ERP. Check existing distinct/dropdown
//                hooks before creating anything new.
//   - dateRange: there is already a DateRange filter in the codebase — adopt that
//                pattern when integrating. Do NOT build a new one.

export const customerInvestmentsSearchSchema = z.object({
  crtPeriod: monthStartString.optional(),
  productCategory: z.enum(PRODUCT_CATEGORIES).optional(),
  investmentCategory: z.enum(INVESTMENT_CATEGORIES).optional(),
  investmentType: z.array(z.string()).optional(),
  contractClause: z.array(z.string()).optional(),
  materialGroupCode: z.array(z.string()).optional(),
  marking: z.array(z.string()).optional(),
  budgetAllocation: z.array(z.string()).optional(),
  hierarchyErp: z.array(z.string()).optional(),
  keyword: z.string().optional(),
  loadedVersionId: z.number().optional(),
  manualInvestmentIds: z.array(z.number()).optional(),
  ...datatableSearchSchema.shape,
})

export type CustomerInvestmentsSearch = z.infer<typeof customerInvestmentsSearchSchema>

export type CustomerInvestmentsResponse = Awaited<ReturnType<typeof fetchCustomerInvestments>>
export type CustomerInvestmentsRow = CustomerInvestmentsResponse['results'][number]
export type CustomerInvestmentsTotals = CustomerInvestmentsResponse['totals']

async function fetchCustomerInvestments(search: CustomerInvestmentsSearch, signal?: AbortSignal) {
  const api = getApi()
  const res = await api.crt['customer-investments'].$get(
    { query: stringifyValues(search) },
    { init: { signal } },
  )
  return await res.json()
}

export function useCustomerInvestments(queries: CustomerInvestmentsSearch) {
  return useQuery({
    queryKey: ['customerInvestments', queries],
    queryFn: ({ signal }) => fetchCustomerInvestments(queries, signal),
  })
}
